import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "size": "small",
      "title": "筛选"
    }
  }, [_c('div', [_c('a-form-model', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-row', {
    staticClass: "fold"
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "日期范围",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修状态",
      "prop": "repairsStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择维修状态"
    },
    model: {
      value: _vm.form.repairsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "repairsStatus", $$v);
      },
      expression: "form.repairsStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("草稿")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("待受理")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待派单")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("待接单")]), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("不受理")]), _c('a-select-option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("维修中")]), _c('a-select-option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("已完成")]), _c('a-select-option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("已评价")]), _c('a-select-option', {
    attrs: {
      "value": 8
    }
  }, [_vm._v("外部维修")])], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "html-type": "submit"
    },
    on: {
      "click": _vm.searchSubmit
    }
  }, [_vm._v(" 查询 ")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.form.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)]), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "报修单列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "templateTable",
    attrs: {
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "rowKey": "number",
      "scroll": {
        y: 500
      },
      "size": "middle",
      "loading": _vm.loading
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis"
        }, [_vm._v(_vm._s(row.organName) + " / " + _vm._s(row.postName))])];
      }
    }, {
      key: "repairsStatus",
      fn: function fn(repairsStatus, row) {
        return [0 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待受理")]) : _vm._e(), 2 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待派单")]) : _vm._e(), 3 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待接单")]) : _vm._e(), 4 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("不受理")]) : _vm._e(), 5 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("维修中")]) : _vm._e(), 6 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("已评价")]) : _vm._e(), 7 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("已完成")]) : _vm._e(), 8 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("外部维修")]) : _vm._e(), 9 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("补　录")]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        }), _c('a-popconfirm', {
          attrs: {
            "title": "是否确认删除",
            "ok-text": "是",
            "cancel-text": "否",
            "id": "btnn",
            "visible": _vm.visibleShow && record.id == _vm.visibleShowId
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteRigister(record.id);
            },
            "cancel": _vm.deleteCancel
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewRigister(record);
            }
          }
        }, [_vm._v("查看")])], 1), record.repairsStatus == 0 ? _c('a-menu-item', {
          key: "2"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.editRigister(record);
            }
          }
        }, [_vm._v("编辑")])], 1) : _vm._e(), record.repairsStatus == 0 ? _c('a-menu-item', {
          key: "3"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.changeClear(record);
            }
          }
        }, [_vm._v("删除")])], 1) : _vm._e(), record.repairsStatus == 0 ? _c('a-menu-item', {
          key: "5"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.listSubmit(record);
            }
          }
        }, [_vm._v("提交")])], 1) : _vm._e(), record.repairsStatus == 7 ? _c('a-menu-item', {
          key: "4"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.evaluationClick(record);
            }
          }
        }, [_vm._v(" 评价 ")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    attrs: {
      "slot": "extra",
      "id": "cccc"
    },
    slot: "extra"
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addRigister
    }
  }, [_vm._v("报修单")])], 1)])], 2)], 1), _c('a-modal', {
    attrs: {
      "title": "编辑报修单",
      "visible": _vm.editRigisterStatus,
      "centered": true,
      "maskClosable": false,
      "width": "40%",
      "footer": null
    },
    on: {
      "ok": _vm.editRigisterSubmit,
      "cancel": _vm.editRigisterCancel
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#edf6fd",
      "padding": "10px",
      "margin-bottom": "10px",
      "letter-spacing": "1px"
    }
  }, [_vm._v(" 各位老师： "), _c('br'), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 欢迎您使用“运维报修”系统！我们希望此系统的使用，可以节约您宝贵的时间，同时提高我们的工作效率，在您使用本系统过程中，有任何不便请直接反馈给我们，谢谢！请您在使用的过程中注意以下几点: ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 1、请务必准确选择报修物品类别，便于系统更精准的把您的保修单分配给正确的维修组； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 2、请尽量清楚的描述故障原因和其他说明，以便组长安排合适的维修人员以及维修人员准备的相应工具； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 3、在填写维修地点时，请首先依次选择楼宇、楼层、房间。如果找不到房间，您可以手动输入地点； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 4、在提交报修单之前，请确认您的联系电话是否准确，请修改正确后再提交报修单。 ")])]), _c('a-form-model', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.editFormRules
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "报修人",
      "prop": "userName",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "disabled": "",
      "placeholder": "报修人"
    },
    model: {
      value: _vm.editForm.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "userName", $$v);
      },
      expression: "editForm.userName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "联系电话"
    },
    model: {
      value: _vm.editForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "phone", $$v);
      },
      expression: "editForm.phone"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备名称",
      "prop": "itemName",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-select', {
    attrs: {
      "default-value": "电脑",
      "placeholder": "设备名称"
    },
    model: {
      value: _vm.editForm.itemName,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "itemName", $$v);
      },
      expression: "editForm.itemName"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "电脑"
    }
  }, [_vm._v("电脑")]), _c('a-select-option', {
    attrs: {
      "value": "投影"
    }
  }, [_vm._v("投影")]), _c('a-select-option', {
    attrs: {
      "value": "展台"
    }
  }, [_vm._v("展台")]), _c('a-select-option', {
    attrs: {
      "value": "中控"
    }
  }, [_vm._v("中控")]), _c('a-select-option', {
    attrs: {
      "value": "讲台"
    }
  }, [_vm._v("讲台")]), _c('a-select-option', {
    attrs: {
      "value": "音响"
    }
  }, [_vm._v("音响")]), _c('a-select-option', {
    attrs: {
      "value": "其他"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备编号",
      "prop": "itemNum",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备编号"
    },
    model: {
      value: _vm.editForm.itemNum,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "itemNum", $$v);
      },
      expression: "editForm.itemNum"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备位置",
      "prop": "location",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "A栋门牌号"
    },
    model: {
      value: _vm.editForm.location,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "location", $$v);
      },
      expression: "editForm.location"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "组织岗位",
      "prop": "organPostId",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-cascader', {
    attrs: {
      "default-value": _vm.defaultValue,
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.editForm.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "editForm.organPostId"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障时间",
      "prop": "reDate",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-date-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD",
      "default-value": _vm.editForm.reDate
    },
    model: {
      value: _vm.editForm.reDate,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "reDate", $$v);
      },
      expression: "editForm.reDate"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "预约维修时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "预约维修时间"
    },
    model: {
      value: _vm.editForm.makeServiceDate,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "makeServiceDate", $$v);
      },
      expression: "editForm.makeServiceDate"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 20
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障描述",
      "prop": "description",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "故障描述",
      "auto-size": {
        minRows: 3,
        maxRows: 5
      },
      "maxLength": 300
    },
    model: {
      value: _vm.editForm.description,
      callback: function callback($$v) {
        _vm.$set(_vm.editForm, "description", $$v);
      },
      expression: "editForm.description"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 20
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".pdf,.doc,.docx,.jpg,.jpge,.png",
      "customRequest": _vm.reviseActionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.reviseDelFile,
      "fileList": _vm.editfileList,
      "defaultFileList": _vm.editfileList
    },
    model: {
      value: _vm.editfileList,
      callback: function callback($$v) {
        _vm.editfileList = $$v;
      },
      expression: "editfileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1), _c('div', _vm._l(_vm.newImgList, function (item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "line-height": "30px",
        "color": "#349eff",
        "cursor": "pointer",
        "justify-content": "space-between",
        "width": "100%"
      },
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_c('div', [_c('a-icon', {
      staticStyle: {
        "color": "rgba(0, 0, 0, 0.45)",
        "padding": "4px 8px 5px 4px"
      },
      attrs: {
        "type": "paper-clip"
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")], 1), _c('div', [_c('a-icon', {
      staticStyle: {
        "color": "rgba(0, 0, 0, 0.45)"
      },
      attrs: {
        "type": "delete"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deletImg(item);
        }
      }
    })], 1)]);
  }), 0)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "popButton"
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.editRigisterCancel
    }
  }, [_vm._v("取消")]), _c('a-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.editSaveSubmit
    }
  }, [_vm._v("保存")]), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editRigisterSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "新增报修单",
      "visible": _vm.addRigisterStatus,
      "centered": true,
      "maskClosable": false,
      "width": "40%",
      "footer": null
    },
    on: {
      "ok": _vm.addRigisterSubmit,
      "cancel": _vm.addRigisterCancel
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#edf6fd",
      "padding": "10px",
      "margin-bottom": "10px",
      "letter-spacing": "1px"
    }
  }, [_vm._v(" 各位老师： "), _c('br'), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 欢迎您使用“运维报修”系统！我们希望此系统的使用，可以节约您宝贵的时间，同时提高我们的工作效率，在您使用本系统过程中，有任何不便请直接反馈给我们，谢谢！请您在使用的过程中注意以下几点: ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 1、请务必准确选择报修物品类别，便于系统更精准的把您的报修单分配给正确的维修组； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 2、请尽量清楚的描述故障原因和其他说明，以便组长安排合适的维修人员以及维修人员准备的相应工具； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 3、在填写维修地点时，请首先依次选择楼宇、楼层、房间。如果找不到房间，您可以手动输入地点； ")]), _c('div', {
    staticStyle: {
      "text-indent": "28px"
    }
  }, [_vm._v(" 4、在提交报修单之前，请确认您的联系电话是否准确，请修改正确后再提交报修单。 ")])]), _c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.addFormRules
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "报修人",
      "prop": "createPerson",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "报修人",
      "disabled": ""
    },
    model: {
      value: _vm.addForm.createPerson,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "createPerson", $$v);
      },
      expression: "addForm.createPerson"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "联系电话",
      "prop": "createPersonPhone",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "联系电话"
    },
    model: {
      value: _vm.addForm.createPersonPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "createPersonPhone", $$v);
      },
      expression: "addForm.createPersonPhone"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备名称",
      "prop": "itemName",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-select', {
    attrs: {
      "default-value": "电脑",
      "placeholder": "设备名称"
    },
    model: {
      value: _vm.addForm.itemName,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "itemName", $$v);
      },
      expression: "addForm.itemName"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "电脑"
    }
  }, [_vm._v("电脑")]), _c('a-select-option', {
    attrs: {
      "value": "投影"
    }
  }, [_vm._v("投影")]), _c('a-select-option', {
    attrs: {
      "value": "展台"
    }
  }, [_vm._v("展台")]), _c('a-select-option', {
    attrs: {
      "value": "中控"
    }
  }, [_vm._v("中控")]), _c('a-select-option', {
    attrs: {
      "value": "讲台"
    }
  }, [_vm._v("讲台")]), _c('a-select-option', {
    attrs: {
      "value": "音响"
    }
  }, [_vm._v("音响")]), _c('a-select-option', {
    attrs: {
      "value": "其他"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备编号",
      "prop": "equipmentNumber",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "设备编号"
    },
    model: {
      value: _vm.addForm.equipmentNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "equipmentNumber", $$v);
      },
      expression: "addForm.equipmentNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "设备位置",
      "prop": "location",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "A栋门牌号"
    },
    model: {
      value: _vm.addForm.location,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "location", $$v);
      },
      expression: "addForm.location"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "组织岗位",
      "prop": "organPostId",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-cascader', {
    attrs: {
      "default-value": _vm.defaultValue,
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.addForm.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "addForm.organPostId"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障时间",
      "prop": "faultTime",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 17
      }
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "258px"
    },
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.addForm.faultTime,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "faultTime", $$v);
      },
      expression: "addForm.faultTime"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "预约维修时间",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "预约维修时间"
    },
    model: {
      value: _vm.addForm.makeServiceDate,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "makeServiceDate", $$v);
      },
      expression: "addForm.makeServiceDate"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "故障描述",
      "prop": "description",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "故障描述",
      "auto-size": {
        minRows: 3,
        maxRows: 5
      },
      "maxLength": 300
    },
    model: {
      value: _vm.addForm.description,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "description", $$v);
      },
      expression: "addForm.description"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 20
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 20
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".pdf,.doc,.docx,.jpg,.jpge",
      "file-list": _vm.addForm.fileList,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.delFile,
      "default-file-list": _vm.addForm.fileList
    },
    model: {
      value: _vm.addForm.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.addForm, "fileList", $$v);
      },
      expression: "addForm.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "popButton"
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.addRigisterCancel
    }
  }, [_vm._v("取消")]), _c('a-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.addSaveSubmit
    }
  }, [_vm._v("保存")]), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRigisterSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };